export default __webpack_public_path__ + "static/media/myAppsLogin.f572abc2.png";